import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

const getSnapshotCallable = httpsCallable(functions, 'getGuidedCareJourneySnapshot');
const proposeCustomPlanCallable = httpsCallable(functions, 'proposeCustomJourneyPlan');
const startCustomPlanCallable = httpsCallable(functions, 'startCustomJourneyPlan');
const correctCustomPlanCallable = httpsCallable(functions, 'correctCustomJourneyPlan');

export const getGuidedCareJourneyErrorMessage = (error) => {
  const code = String(error?.code || '').toLowerCase();
  const message = String(error?.message || '').trim();
  if (code === 'functions/internal' || code === 'internal' || message.toLowerCase() === 'internal') {
    return "We couldn't prepare this journey right now. Please try again.";
  }
  return message || 'This journey is not available right now.';
};

export const getGuidedCareJourneySnapshot = async ({
  childId,
  journeyId = 'iep_meeting',
  draftId = 'iep_meeting-v3-current',
  enhance = true,
} = {}) => {
  if (!childId) throw new Error('Choose a person before opening this journey.');
  let response;
  try {
    response = await getSnapshotCallable({ childId, journeyId, draftId, enhance, timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC' });
  } catch (error) {
    throw new Error(getGuidedCareJourneyErrorMessage(error));
  }
  if (!response.data?.areas) throw new Error('This journey is not available right now.');
  return response.data;
};

export const proposeCustomJourneyPlan = async ({ childId, purpose }) => {
  if (!childId) throw new Error('Choose a person before preparing.');
  const response = await proposeCustomPlanCallable({ childId, purpose });
  if (!response.data?.proposal) throw new Error("We couldn't create a preparation plan right now.");
  return response.data;
};

export const startCustomJourneyPlan = async ({ childId, proposal, draftId }) => {
  if (!childId) throw new Error('Choose a person before preparing.');
  const response = await startCustomPlanCallable({ childId, proposal, draftId });
  if (!response.data?.draftId || !response.data?.route) {
    throw new Error("We couldn't start this preparation right now.");
  }
  return response.data;
};

export const correctCustomJourneyPlan = async ({ childId, draftId }) => {
  if (!childId || !draftId) throw new Error('Choose a preparation to update.');
  const response = await correctCustomPlanCallable({ childId, draftId });
  if (!response.data?.updated && !response.data?.alreadyCorrected) {
    throw new Error("We couldn't update this preparation plan right now.");
  }
  return response.data;
};

export default getGuidedCareJourneySnapshot;
